// main.css is loaded via a real <link rel="stylesheet"> in each static
// page's <head> now, not imported here — see privacy.html's comment on
// that line for why a JS import alone caused a FOUC on these static pages.
// The initial theme class is set before paint by public/theme-init.js.
import { createIcons, Moon, Sun } from 'lucide';

document.addEventListener('DOMContentLoaded', () => {
  createIcons({ icons: { Moon, Sun } });
});

// Mobile menu: below the md breakpoint the header's nav links are hidden, so
// the hamburger button reveals the same links in a dropdown panel. Closes on
// link tap, Escape, and when the viewport grows past md (where the full nav is
// visible and the panel would otherwise stay open invisibly).
const menuButton = document.getElementById('mobileMenuButton');
const mobileMenu = document.getElementById('mobileMenu');
if (menuButton && mobileMenu) {
  const setMenuOpen = (open) => {
    mobileMenu.classList.toggle('hidden', !open);
    menuButton.setAttribute('aria-expanded', String(open));
    menuButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    document.getElementById('menuIconOpen')?.classList.toggle('hidden', open);
    document.getElementById('menuIconClose')?.classList.toggle('hidden', !open);
  };
  menuButton.addEventListener('click', () => setMenuOpen(mobileMenu.classList.contains('hidden')));
  mobileMenu.addEventListener('click', (e) => {
    if (e.target.closest('a')) setMenuOpen(false);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') setMenuOpen(false);
  });
  window.matchMedia('(min-width: 768px)').addEventListener('change', (e) => {
    if (e.matches) setMenuOpen(false);
  });
}

// Writes the same per-profile key the app reads (useAppStore's
// themePreference), so flipping the theme here carries over to the player
// instead of living in a separate legacy key.
document.getElementById('toggleDarkMode')?.addEventListener('click', () => {
  const isDark = document.documentElement.classList.toggle('dark');
  try {
    const profileId = localStorage.getItem('openplay:activeProfileId') || 'default';
    localStorage.setItem(`openplay:profile:${profileId}:themePreference`, isDark ? 'dark' : 'light');
  } catch {
    // Storage unavailable — the toggle still works for this page view.
  }
});
